import { render, staticRenderFns } from "./dwmcbgbq_month.vue?vue&type=template&id=f03076d2&scoped=true&"
import script from "./dwmcbgbq_month.vue?vue&type=script&lang=js&"
export * from "./dwmcbgbq_month.vue?vue&type=script&lang=js&"
import style0 from "./dwmcbgbq_month.vue?vue&type=style&index=0&id=f03076d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03076d2",
  null
  
)

export default component.exports